<script setup lang="ts">
interface Props {
  color?: string;
  spacing?: string;
  constrained?: boolean;
}

const { color = 'bg-brand-200/50', spacing = '', constrained = false } = defineProps<Props>();
</script>

<template>
  <div :class="constrained && 'px-6 lg:container lg:mx-auto xl:px-25'">
    <div :class="`h-[1px] w-full ${spacing} ${color}`"></div>
  </div>
</template>
